var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
/**
 * NotificationCard Component
 *
 * A notification card component designed to display messages or alerts with customizable colors and sizes.
 * The card can be used to showcase important notifications, messages, or status updates in a variety of styles.
 *
 * @param [props.color='default'] - The color scheme applied to the notification card.
 * - 'default': Default color scheme with light background and text.
 * - 'primary': Primary color scheme, typically used for important notifications.
 * - 'danger': Red color scheme for error notifications.
 * - 'success': Green color scheme for success messages.
 * - 'alert' : Yellow color scheme for alert or warning notifications.
 *
 * @param {'sm' | 'default'} [props.size='default'] - The size of the notification card.
 * - 'sm': A smaller notification card with less padding and a compact appearance.
 * - 'default': The standard size with normal padding and proportions.
 *
 * @example
 * // Default notification card with success color
 * <NotificationCard color="success" size="default">Success Notification</NotificationCard>
 *
 * @example
 * // Small notification card with danger color
 * <NotificationCard color="danger" size="sm">Error Notification</NotificationCard>
 *
 * @example
 * // Default notification card with primary color
 * <NotificationCard color="primary">Primary Notification</NotificationCard>
 */
export var NotificationCard = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-radius: var(--card-border-radius);\n    box-shadow: var(--container-shadow-color-100);\n    margin-bottom: var(--space-sm);\n    position: relative;\n\n    /* Default padding for the notification card */\n    padding: var(--space) var(--card-padding);\n\n    color: var(--badge-plain);\n    background: var(--badge-plain-light);\n    border: 1px solid var(--badge-plain-border);\n\n    ", "\n\n    ", ";\n"], ["\n    border-radius: var(--card-border-radius);\n    box-shadow: var(--container-shadow-color-100);\n    margin-bottom: var(--space-sm);\n    position: relative;\n\n    /* Default padding for the notification card */\n    padding: var(--space) var(--card-padding);\n\n    color: var(--badge-plain);\n    background: var(--badge-plain-light);\n    border: 1px solid var(--badge-plain-border);\n\n    ", "\n\n    ", ";\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b;
    if (size === 'sm') {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                padding: var(--space) var(--space-sm); /* Smaller padding for 'sm' size */\n            "], ["\n                padding: var(--space) var(--space-sm); /* Smaller padding for 'sm' size */\n            "])));
    }
}, function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'default' : _b;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            color: var(--badge-", ");\n            background-color: var(--badge-", "-light);\n            border: 1px solid var(--badge-", "-border);\n        "], ["\n            color: var(--badge-", ");\n            background-color: var(--badge-", "-light);\n            border: 1px solid var(--badge-", "-border);\n        "])), color, color, color);
});
NotificationCard.defaultProps = {
    size: 'default',
    color: 'plain',
};
var templateObject_1, templateObject_2, templateObject_3;
